const BirthdayRoute = [
  {
    path: '/birthday',
    component: () => import('../pages/birthday/'),
    children: [
      {
        path: 'cake',
        name: 'BirthdayCake',
        component: () => import('../pages/birthday/cake'),
        meta: {
          title: '生日会',
        },
      },
      {
        path: 'list',
        name: 'BirthdayList',
        component: () => import('../pages/birthday/list'),
        meta: {
          title: '生日会',
        },
      },
    ],
  },
];

export default BirthdayRoute;
